module.exports = __webpack_public_path__ + "static/Book4-70719e12e84cb69f99f34898a76fd7d2.jpg";